import styled from 'styled-components';

import { Grid, defaultThemeProp } from '@pega/cosmos-react-core';

export const StyledGrid = styled(Grid)`
  max-width: 60rem;
`;

export const StyledCodeBlock = styled.pre`
  padding: ${props => props.theme.base.spacing};
  margin-bottom: ${props => props.theme.base.spacing};
`;
StyledCodeBlock.defaultProps = defaultThemeProp;

export const StyledList = styled.ul`
  padding-left: calc(4 * ${props => props.theme.base.spacing});
`;
StyledList.defaultProps = defaultThemeProp;
